function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  padding: 0;\n  font-weight: unset;\n\n  &:hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Check } from 'pcln-icons';
import { Button } from '../Button';
import { Text } from '../Text';
import { getPaletteColor } from '../utils';
var StepperFlex = styled(Button)(_templateObject(), getPaletteColor('background.lightest'), getPaletteColor('base'), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, getPaletteColor('background.lightest'));

function Step(_ref) {
  var className = _ref.className,
      active = _ref.active,
      completed = _ref.completed,
      children = _ref.children,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["className", "active", "completed", "children", "onClick"]);

  var color = active || completed ? 'primary' : 'text.light';
  return /*#__PURE__*/React.createElement(StepperFlex, _extends({
    className: className,
    alignItems: "center",
    onClick: onClick
  }, props), completed && /*#__PURE__*/React.createElement(Check, {
    color: "primary",
    size: 16,
    mr: 1,
    "aria-hidden": false,
    "aria-label": "Step Completed"
  }), /*#__PURE__*/React.createElement(Text, {
    color: color,
    bold: active,
    fontSize: 1,
    "aria-selected": active
  }, children));
}

Step.displayName = 'Step';
Step.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  completed: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};
Step.defaultProps = {
  className: '',
  active: false,
  completed: false
};
export default Step;